import { render, staticRenderFns } from "./SettingsMediaPicker.vue?vue&type=template&id=84376cbe&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SettingsMediaPicker.vue?vue&type=script&lang=js&"
export * from "./SettingsMediaPicker.vue?vue&type=script&lang=js&"
import style0 from "../../Style/settings-media-picker.scss?vue&type=style&index=0&id=84376cbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84376cbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84376cbe')) {
      api.createRecord('84376cbe', component.options)
    } else {
      api.reload('84376cbe', component.options)
    }
    module.hot.accept("./SettingsMediaPicker.vue?vue&type=template&id=84376cbe&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&", function () {
      api.rerender('84376cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/SettingsMediaPicker.vue"
export default component.exports